var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paywall"},[_c('iframe',{ref:"frame",attrs:{"src":_vm.source,"seamless":"","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }